export const states = {
  start: 'start',
  inProgress: 'in_progress',
  inProgressCantUpdate: 'in_progress_cant_update',
  completed: 'completed',
  update: 'update',
  autoRequestCancel: 'auto_request_canceled',
  cancel: 'cancel',
  done: 'done',
};

export const etaTypes = {
  arrival: 'arrival',
  dropoff: 'dropoff',
};

export const results = {
  success: 'success',
  failed: 'failed',
};

export const TASK_TYPE = {
  NAVIGATION: 'NAVIGATION',
  DELIVERY: 'DELIVERY',
  CHARGE: 'CHARGE',
};

export const TASK_STATUS = {
  UNASSIGNED: 'UNASSIGNED',
  ASSIGNED: 'ASSIGNED',
  IN_PROGRESS: 'IN_PROGRESS',
  INTERRUPTED: 'INTERRUPTED',
  CANCELED: 'CANCELED',
  FAILED: 'FAILED',
  COMPLETED: 'COMPLETED',
  CANCEL_REQUESTED: 'CANCEL_REQUESTED',
  CLAIMED: 'CLAIMED',
};

export const TASK_TAG = {
  SCHEDULED: 'SCHEDULED',
  ON_DEMAND: 'ON_DEMAND',
  BATCH_1M: 'BATCH_1:M',
  BATCH_M1: 'BATCH_M:1',
  TEST: 'TEST',
  MANUAL_DELIVERY: 'MANUAL_DELIVERY',
  CANCELED_BY_STAFF_ON_ARRIVAL: 'CANCELED_BY_STAFF_ON_ARRIVAL',
  CANCELED_ROBOT_MALFUNCTION: 'CANCELED_ROBOT_MALFUNCTION',
  CANCELED_BATCH_WORKFLOW: 'CANCELED_BATCH_WORKFLOW',
  CANCELED_UNSPECIFIED: 'CANCELED_UNSPECIFIED',
  COMPLETED_MANUALLY: 'COMPLETED_MANUALLY',
  COMPLETED_BY_OTHER_MOXI_TASK: 'COMPLETED_BY_OTHER_MOXI_TASK',
  NOT_COMPLETED: 'NOT_COMPLETED',
  COMPLETED_UNSPECIFIED: 'COMPLETED_UNSPECIFIED',
};

export const STEP_STATUS = {
  TO_DO: 'TO_DO',
  IN_PROGRESS: 'IN_PROGRESS',
  INTERRUPTED: 'INTERRUPTED',
  FAILED: 'FAILED',
  CANCELED: 'CANCELED',
  COMPLETED: 'COMPLETED',
};

export const STEP_TYPE = {
  GO_TO: 'GO_TO',
  LOAD: 'LOAD',
  UNLOAD: 'UNLOAD',
  DOCK_WITH_CHARGER: 'DOCK_WITH_CHARGER',
};

export const REQUIRED_ROLE = {
  BASIC: 'BASIC',
  RESTRICTED: 'RESTRICTED',
};

export const STEP_ORDER_DELIVERY = [STEP_TYPE.GO_TO, STEP_TYPE.LOAD, STEP_TYPE.GO_TO, STEP_TYPE.UNLOAD];

export const V1_LOAD_STEP_TYPE = 'load_tube';
export const V1_UNLOAD_STEP_TYPE = 'unload_tube';

export const ONE_TO_MANY = 'oneToMany';
export const MANY_TO_ONE = 'manyToOne';

export const DRAWER_CONFIDENCE = {
  LOW: 'Low',
  HIGH: 'High'
};
